import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'
import { CancelReplacementResponse } from 'api/newDLTransferAPI'

type State = {
  errorMessage: string
} & Status

const initialState = {
  errorMessage: '',
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.E_TO_I_CANCEL_REPLACEMENT_ASYNC,
    Actions.E_TO_I_CANCEL_REPLACEMENT_SUCCESS,
    Actions.E_TO_I_CANCEL_REPLACEMENT_FAIL,
    CancelReplacementResponse,
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.E_TO_I_CANCEL_REPLACEMENT_ASYNC:
    case Actions.E_TO_I_CANCEL_REPLACEMENT_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.E_TO_I_CANCEL_REPLACEMENT_FAIL: {
      return {
        ...state,
        errorMessage: action.payload?.error?.message || '',
        ...action.status,
      }
    }

    default:
      return state
  }
}
